type PickupLocationParts = {
  title?: string | null
  address?: string | null
  phone?: string | null
}

const clean = (value?: string | null) => (value ?? '').trim()

export const formatPickupLocation = ({
  title,
  address,
  phone,
}: PickupLocationParts) => {
  const place = [title, address].map(clean).filter(Boolean).join(', ')
  const phoneText = clean(phone)
  return phoneText ? `${place} · ${phoneText}` : place
}
